export default __webpack_public_path__ + "static/media/hht2_sitcom_18.d653c5bd.png";